import React, { useEffect, useState } from 'react';
import {
    Box,
    Slider,
    Typography,
    Stack,
} from '@mui/material';
import { AppConfigs, AppSkinProps, CriteriaConstraint } from '../../../../types/decisions';

const sliderLeftLabel = 'Less important';
const sliderRightLabel = 'More important';

const CustomSelectSetting2 = ({
    id,
    items,
    onTradeoffValueChange,
    setCriteriaConstraints,
    criteriaConstraints,
    disabled = false,
    title,
    description,
}: {
    disabled?: boolean;
    importance: number;
    items: {
        name: string;
        value: number | string;
        icon: string;
        link: string;
    }[];
    hideValues?: boolean;
    showAddConstraint?: boolean;
    hideImportance?: boolean;
    onSliderChange: AppSkinProps['onSliderChange'];
    onTradeoffValueChange: AppSkinProps['onTradeoffValueChange']
    initialValues: Record<string, string>;
    id: string;
    criteriaConstraints: Record<string, CriteriaConstraint[]>;
    setCriteriaConstraints: (value: (((prevState: { [p: string]: CriteriaConstraint[]; }) => {
        [p: string]: CriteriaConstraint[];
    }) | { [p: string]: CriteriaConstraint[]; })) => void;
    variant?: AppConfigs['criteriaSettings']['enumerated'];
    isModal?: boolean;
    onCriteriaSettingsOpen?: (id: string) => void;
    title: string;
    description: string;
}) => {
    const [ itemValues, setItemValues ] = useState<{
        [key: string]: {
            isChecked: boolean;
            value: string;
        }
    }>({});

    useEffect(() => {
        if (!criteriaConstraints[id]) {
            setCriteriaConstraints(criteriaConstraints => (
                {
                    ...criteriaConstraints,
                    [id]: [],
                }
            ));
        }

        const itemsChecked: { [key: string]: { isChecked: boolean; value: string; } } = {};
        items.forEach(item => {
            itemsChecked[item.name] = {
                isChecked: item.value !== '-1',
                value: item.value as string,
            };
        });
        setItemValues(itemsChecked);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Stack spacing={4}>
            <Box>
                <Typography
                    sx={{
                        fontSize: { xs: 28, md: 38 },
                        lineHeight: 1.2,
                        fontWeight: 700,
                        color: '#1e2f46',
                        mb: 1,
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    sx={{
                        fontSize: { xs: 12, md: 16 },
                        color: '#667892',
                        lineHeight: 1.5,
                    }}
                >
                    {description}
                </Typography>
            </Box>

            <Stack spacing={1.5}>
                {items.map((item, idx) => (
                    <>
                        <Typography
                            sx={{
                                fontSize: { xs: 14, md: 18 },
                                color: '#1e2f46',
                                // : '#5f6f86',
                            }}
                        >
                            {item.name}
                        </Typography>
                        <Box sx={{ px: { xs: 0, md: 1 } }}>
                            <Slider
                                defaultValue={100 - 20 * (idx + 1)}
                                min={0}
                                max={100}
                                step={1}
                                disabled={!itemValues[item.name]?.isChecked || disabled}
                                value={+itemValues[item.name]?.value}
                                onChange={(_, value) => {
                                    setItemValues(items => (
                                        {
                                            ...items,
                                            [item.name]: {
                                                ...items[item.name],
                                                value: value + '',
                                            },
                                        }
                                    ));
                                }}
                                onChangeCommitted={(_, value) => onTradeoffValueChange(value, id, item.name)}
                                sx={{
                                    height: 10,
                                    color: '#173f73',
                                    '& .MuiSlider-rail': {
                                        opacity: 1,
                                        backgroundColor: '#e3e8ee',
                                        height: 10,
                                        borderRadius: 999,
                                    },
                                    '& .MuiSlider-track': {
                                        border: 'none',
                                        height: 10,
                                        borderRadius: 999,
                                        backgroundColor: '#173f73',
                                    },
                                    '& .MuiSlider-thumb': {
                                        width: 24,
                                        height: 24,
                                        backgroundColor: '#fff',
                                        border: '4px solid #173f73',
                                        boxShadow: 'none',
                                        '&:hover, &.Mui-focusVisible, &.Mui-active': {
                                            boxShadow: 'none',
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </>
                ))}
            </Stack>

            <Box sx={{ pt: 1 }}>
                <Box
                    sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 2,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: 14, md: 18 },
                            color: '#667892',
                            fontWeight: 500,
                        }}
                    >
                        {sliderLeftLabel}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: { xs: 14, md: 18 },
                            color: '#667892',
                            fontWeight: 500,
                            textAlign: 'right',
                        }}
                    >
                        {sliderRightLabel}
                    </Typography>
                </Box>
            </Box>
        </Stack>

    );
};

export default CustomSelectSetting2;
